export const apiServer = {
  url: process.env.REACT_APP_API_BASE_URL,
  timeout: 3000
}